__turbopack_context__.v({
  "checkbox": "FeaturesList-module-scss-module__obdYHW__checkbox",
  "icon": "FeaturesList-module-scss-module__obdYHW__icon",
  "item": "FeaturesList-module-scss-module__obdYHW__item",
  "list": "FeaturesList-module-scss-module__obdYHW__list",
  "name": "FeaturesList-module-scss-module__obdYHW__name",
  "tooltip": "FeaturesList-module-scss-module__obdYHW__tooltip",
  "tooltipTrigger": "FeaturesList-module-scss-module__obdYHW__tooltipTrigger",
});
